module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nif(model.properties){\nif(model.properties.active)     additionalClasses.push('active');\nif(model.properties.actual)     additionalClasses.push('actual');\nif(model.properties.next)       additionalClasses.push('next');\nif(model.properties.previous)   additionalClasses.push('previous');\n}\nelse {\nadditionalClasses.push('problem');\n}\n%>\n<div class=\"<%- additionalClasses.join(' ') %>\">\n<div class=\"windowWrapper\">\n<%- helpers.renderSection('windows') %>\n</div>\n<div class=\"sliderWrapper\">\n<div class=\"slider blue\"></div>\n</div>\n</div>"
  , __filename = "components/layouts/column/column.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
if(model.properties){
if(model.properties.active)     additionalClasses.push('active');
if(model.properties.actual)     additionalClasses.push('actual');
if(model.properties.next)       additionalClasses.push('next');
if(model.properties.previous)   additionalClasses.push('previous');
}
else {
additionalClasses.push('problem');
}

    ; __line = 12
    ; __append("\n<div class=\"")
    ; __line = 13
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n<div class=\"windowWrapper\">\n")
    ; __line = 15
    ; __append( helpers.renderSection('windows') )
    ; __append("\n</div>\n<div class=\"sliderWrapper\">\n<div class=\"slider blue\"></div>\n</div>\n</div>")
    ; __line = 20
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/layouts/column/column.ejs

}